export function enableScrolling(){
    window.onscroll=function(){};
}